import { brand } from '../config/brand';

export function Logo({ compact = false }: { compact?: boolean }) {
  return <img className={compact ? 'brand-logo brand-logo--compact' : 'brand-logo'} src={compact ? brand.mark : brand.logo} alt="WALLD Studio" />;
}
